import React, { useState } from 'react';
import styled from 'styled-components';

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
`;

const ExportButton = styled.button`
  background-color: ${props => props.disabled ? '#ccc' : '#27AE60'};
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background-color: ${props => props.disabled ? '#ccc' : '#1e8449'};
  }

  &:active {
    transform: ${props => props.disabled ? 'none' : 'scale(0.98)'};
  }
`;

const Spinner = styled.div`
  width: 14px;
  height: 14px;
  border: 2px solid #ffffff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

/**
 * Export Buttons Component
 * @param {Function} onExportExcel - Handler for Excel export
 * @param {Function} onExportPDF - Handler for PDF export
 * @param {Boolean} loading - Loading state
 * @param {Boolean} disableExcel - Disable Excel button
 * @param {Boolean} disablePDF - Disable PDF button
 */
const ExportButtons = ({ 
  onExportExcel = null, 
  onExportPDF = null, 
  loading = false,
  disableExcel = false,
  disablePDF = false
}) => {
  const [exporting, setExporting] = useState({ excel: false, pdf: false });

  const handleExcelExport = async () => {
    if (!onExportExcel || loading || exporting.excel) return;
    
    setExporting({ ...exporting, excel: true });
    try {
      await onExportExcel();
    } finally {
      setExporting({ ...exporting, excel: false });
    }
  };

  const handlePDFExport = async () => {
    if (!onExportPDF || loading || exporting.pdf) return;
    
    setExporting({ ...exporting, pdf: true });
    try {
      await onExportPDF();
    } finally {
      setExporting({ ...exporting, pdf: false });
    }
  };

  return (
    <ButtonContainer>
      {onExportExcel && (
        <ExportButton 
          onClick={handleExcelExport} 
          disabled={loading || exporting.excel || disableExcel}
        >
          {exporting.excel ? (
            <>
              <Spinner />
              Exporting...
            </>
          ) : (
            <>
              📊 Export to Excel
            </>
          )}
        </ExportButton>
      )}
      
      {onExportPDF && (
        <ExportButton 
          onClick={handlePDFExport} 
          disabled={loading || exporting.pdf || disablePDF}
        >
          {exporting.pdf ? (
            <>
              <Spinner />
              Generating...
            </>
          ) : (
            <>
              📄 Export to PDF
            </>
          )}
        </ExportButton>
      )}
    </ButtonContainer>
  );
};

export default ExportButtons;


